<template>
  <div class="service-center-card col-12 col-sm-6 col-lg-3">
    <Link :href="card.url" class="d-flex flex-column align-items-center">
      <div class="d-flex flex-column align-items-center icons w-100">
        <span v-if="card.icon.svgIcon" v-html="card.icon.svgIcon"></span>
        <img v-else :src="card.icon.imgLink" alt="icon">
        <RectAngleShape class="service-center-card__line w-100" />
      </div>
      <div class="text-center">{{ card.title }}</div>
    </Link>
  </div>
</template>

<script>
import RectAngleShape from "@/components/common/RectAngleShape";
import Link from "@/components/common/Link";
export default {
  components: {Link, RectAngleShape},
  props: {
    card: {
      icon: {
        imgLink: String,
        svgIcon: String,
      },
      title: String,
      url: String,
    }
  },
}
</script>
